/* eslint-disable @typescript-eslint/ban-ts-comment */
import { PageWrapper, PageWithSidebarProps } from 'components/PageWrapper';

export function withApplicationLayout<T = Record<string, unknown>>() {
  return (Component: React.FC<T>, pageWrapperProps?: Partial<PageWithSidebarProps>): React.FC<T> =>
    (props) =>
      (
        <PageWrapper {...pageWrapperProps}>
          <Component {...props} />
        </PageWrapper>
      );
}
